(function () {
  const form = document.querySelector('[data-header-search]');
  const input = form?.querySelector('.site-header__search-input');
  const results = form?.querySelector('[data-header-search-results]');

  if (!form || !input || !results || input.hasAttribute('data-no-suggestions')) return;

  let timer = null;
  let controller = null;

  function show() { results.classList.add('is-open'); }
  function hide() { results.classList.remove('is-open'); results.innerHTML = ''; }

  function skeleton() {
    return Array.from({ length: 3 }, () => `
      <div class="sk-search-item">
        <div class="sk sk-search-item__img"></div>
        <div class="sk-search-item__info">
          <div class="sk sk--xxs"></div>
          <div class="sk sk--md"></div>
        </div>
      </div>`).join('');
  }

  function render(items, query) {
    if (!items.length) {
      results.innerHTML = '<p class="search-no-results">No results found.</p>';
      return;
    }
    const q = encodeURIComponent(query);
    results.innerHTML = `
      <ul class="search-results-list">
        ${items.map(p => `
          <li class="search-result">
            <a href="${p.url}" class="search-result__link">
              <div class="search-result__img-wrap">
                ${p.image
                  ? `<img src="${p.image}" alt="${p.title}" width="72" height="72" loading="lazy" class="search-result__img">`
                  : '<div class="search-result__img-placeholder"></div>'}
              </div>
              <div class="search-result__info">
                ${p.vendor ? `<p class="search-result__brand">${p.vendor}</p>` : ''}
                <p class="search-result__title">${p.title}</p>
                ${p.price ? `<p class="search-result__price">${p.price}</p>` : ''}
              </div>
            </a>
          </li>`).join('')}
      </ul>
      <a href="/search?type=product&q=${q}" class="search-view-all">View all results</a>`;
  }

  async function search(q) {
    if (!q || q.length < 2) { hide(); return; }

    if (controller) controller.abort();
    controller = new AbortController();

    results.innerHTML = skeleton();
    show();

    try {
      const res = await fetch(`/search?view=search-suggestions&type=product&q=${encodeURIComponent(q)}`, {
        signal: controller.signal
      });
      const data = await res.json();
      render(Array.isArray(data) ? data : [], q);
    } catch (e) {
      if (e.name !== 'AbortError') hide();
    }
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => search(input.value.trim()), 300);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && results.innerHTML) show();
  });

  document.addEventListener('click', e => {
    if (!form.contains(e.target)) hide();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') hide();
  });
})();
